import {sleep} from '@/utils/apiUtils';
import {formatUnit} from '@/utils/unitUtils';
import {NodeHealthData, NodeSummaryData} from '@/views/dashboard/interfaces';
import {httpClient} from './baseApi';

/*
  Получение данных о работниках
*/
export async function requestWorkersData(nodeId: string) {
  console.log(nodeId);
  await sleep(300);

  const data = Math.floor(Math.random() * 10);

  return data;
}

/*
  Получение сводной информации о узле
*/
export async function requestNodeSummaryData(
  nodeId: string,
  startDate: number,
  endDate: number,
): Promise<NodeSummaryData> {
  const {data} = await httpClient.get(`dashboard/widgets/node_summary/get_data/`, {
    params: {
      start_date: startDate,
      end_date: endDate,
      node_id: nodeId,
    },
  });

  const transformedData = {
    lastHitStrength: data.hit_amplitude,
    lastHitStrengthUnit: formatUnit('м/c^2'),
    zeroEnvelopSpectrumHarm: data.noise_level,
    zeroEnvelopSpectrumHarmUnit: 'дБ',
    energy: data.energy_amplitude,
    energyUnit: 'А',
    temperature: data.temperature,
    temperatureUnit: '&#8451;',
    turnovers: data.revs,
    turnoversUnit: 'об/мин',

    //TODO: временно убраны
    //maintenanceRemainingTime: 16,
    //maintenanceRemainingTimeUnit: 'дней',
    //health: 97,
    //healthUnit: '%',
  };

  return transformedData;
}

/*
  Получение данных для виджета здоровья узла
*/
export async function requestNodeHealthData(nodeId: string): Promise<NodeHealthData> {
  console.log(nodeId);
  await sleep(300);

  const data = {
    health: Math.floor(Math.random() * 70),
    healthUnit: '%',
  };

  return data;
}

/*
  Получение данных для детектора ударов
*/
export async function requestHitDetectorData(nodeId: string, startDate: number, endDate: number) {
  const {data} = await httpClient.get(`dashboard/widgets/hit_detector/get_data/`, {
    params: {
      start_date: startDate,
      end_date: endDate,
      node_id: nodeId,
    },
  });

  const nodes: {num: number; id: string; name: string; shortName: string}[] = [];

  const chartData: {x: number; y: number; z: number}[] = [];
  data.forEach(
    (
      d: {
        node_id: string;
        node_name: string;
        node_short_name: string;
        events: {value: number; date: number}[];
      },
      index: number,
    ) => {
      nodes.push({num: index + 1, id: d.node_id, name: d.node_name, shortName: d.node_short_name});
      d.events.forEach(e => {
        chartData.push({x: e.date, y: index + 1, z: e.value});
      });
    },
  );

  return {nodes, chartData};
}
